var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"model-second-title"},[_vm._v(" "+_vm._s(_vm.params.label || _vm.rowData[_vm.params.key])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }